import constant from "../../../../constants/constant";
import { isRegularGstStore } from "../../../../constants/utils";
import { ModifiedTableDataProps, ProductItemsProps } from "../interface"


export const useTableCalculation = () => {

    const modifiedTableData = ({
        data,
        isContactLens,
    }: ModifiedTableDataProps) => {
        let filterCondition = (items: ProductItemsProps) =>
            items?.product?.is_contact_lens === isContactLens;
        return data?.filter(filterCondition).length > 0
            ? [...data?.filter(filterCondition), {}]
            : [];
    };

    //find the to add invoice is gst type or not
    const findInvoiceGstType = (item: any): boolean => {
        return isRegularGstStore() && item?.category === constant.INVOICE_CATEGORY[5].value && item?.gst_invoice
    }
    //end

    // function to get the value
    const getTableValue = (row: ProductItemsProps, key: string) => {
        const initialCost = row?.cost_amount / (1 - (row?.discount_percent * 0.01));
        const cost = initialCost || 0;
        const discountPercent = Number(row?.discount_percent) || 0;

        const discountAmount = cost * discountPercent * 0.01;
        const amountAfterDiscount = Number(Number(cost) - Number(discountAmount)) * Number(row?.quantity);
        const totalGST: number = Number(row?.gst_amount);

        switch (key) {
            case "Unit Cost Amount":
                return initialCost;
            case "Discount Amount":
                return discountAmount.toFixed(2);

            case "Amount":
                return amountAfterDiscount.toFixed(2);

            case "Total GST":
                return totalGST.toFixed(2);

            case "Total Amount":
                return (amountAfterDiscount + totalGST).toFixed(2);

            default:
                return null;
        }
    };
    //end

    // to calculate the total
    const getTotalValue = (
        data: Array<any>,
        key: "Amount" | "Total GST" | "Total Amount",
        isContactLens: boolean
    ): string => {
        const modifiedData = modifiedTableData({ data, isContactLens });

        const total = modifiedData.reduce((sum: number, item: any) => {

            const amountAfterDiscount = item?.cost_amount * item?.quantity;
            const totalGST: number = item?.gst_amount

            let value = 0;
            switch (key) {
                case "Amount":
                    value = amountAfterDiscount;
                    break;
                case "Total GST":
                    value = totalGST;
                    break;
                case "Total Amount":
                    value = amountAfterDiscount + totalGST;
                    break;
            }

            return sum + (isNaN(value) ? 0 : value);
        }, 0);

        return total.toFixed(2);
    };
    //end

    return {
        getTableValue,
        getTotalValue,
        modifiedTableData,
        findInvoiceGstType
    }
}; 